import "../../../../design/contact.css";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { motion, AnimatePresence } from "framer-motion";
import Footer from "../Footer";

export default function Contact() {
    const form = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState({ type: "", message: "" });

    const sendEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatus({ type: "", message: "" });

        try {
            await emailjs.sendForm(
                "service_mz8607l",
                "template_kpa4e54",
                form.current,
                "Y-w-i3WhQ1WOF33bv"
            );

            setStatus({ type: "success", message: "მეილი წარმატებით გაიგზავნა ✨" });
            form.current.reset();
        } catch (error) {
            setStatus({ type: "error", message: "გაგზავნა ვერ მოხერხდა. სცადეთ მოგვიანებით." });
            console.error("EmailJS Error:", error);
        } finally {
            setIsLoading(false);
            // სტატუსი გაქრება 5 წამის შემდეგ
            setTimeout(() => setStatus({ type: "", message: "" }), 5000);
        }
    };

    return (
        <>
            <section id='contact' className="contact-section">
                <div className="contact-blur-circle-1"></div>
                <div className="contact-blur-circle-2"></div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="contact-card-glass"
                >
                    <h2>მოგვწერეთ ნებისმიერ დროს</h2>
                    <p className="subtitle">ჩვენი გუნდი მზად არის დაგეხმაროთ.</p>

                    <form ref={form} onSubmit={sendEmail} className="contact-form">
                        <div className="input-group">
                            <input type="text" name="user_name" placeholder="თქვენი სახელი" required />
                        </div>

                        <div className="input-group">
                            <input type="email" name="user_email" placeholder="თქვენი იმეილი" required />
                        </div>

                        <div className="input-group">
                            <textarea name="message" placeholder="თქვენი შეტყობინება..." rows="5" required />
                        </div>

                        <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            type="submit"
                            disabled={isLoading}
                            className={isLoading ? "loading" : ""}
                        >
                            {isLoading ? "იგზავნება..." : "შეტყობინების გაგზავნა"}
                        </motion.button>
                    </form>

                    <AnimatePresence>
                        {status.message && (
                            <motion.p
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0 }}
                                className={`status-msg ${status.type}`}
                            >
                                {status.message}
                            </motion.p>
                        )}
                    </AnimatePresence>
                </motion.div>
            </section>
            {
                window.location.pathname === "/contact-us" &&
                <Footer />
            }
        </>

    );
}